module.exports = __webpack_public_path__ + "media/books/Books-WhoItsFor-Grandparents-8f9a3dc6.jpg";